import type { PublicSessionFileType } from '../../../api/publicSessionApi';
import type { SessionQuestionEntityFrontend } from '../../../api/sessionQuestionsApi';

export const inferPublicSessionFileType = (
    question: SessionQuestionEntityFrontend,
): PublicSessionFileType => {
    const key = `${question.questionKey ?? ''} ${question.questionDataKey ?? ''}`.toUpperCase();
    if (key.includes('CV') || key.includes('RESUME') || key.includes('CURRICULUM')) return 'CV';
    if (key.includes('VCA')) return 'VCA';
    if (key.includes('DRIVER') || key.includes('LICENSE') || key.includes('RIJBEWIJS')) {
        return 'RIJBEWIJS';
    }
    if (key.includes('REFERENCE') || key.includes('PORTFOLIO') || key.includes('WORK_PHOTO')) {
        return 'REFERENCE';
    }
    if (key.includes('ID') || key.includes('PASSPORT') || key.includes('RESIDENCE')) {
        return 'ID_DOCUMENT';
    }
    if (key.includes('CERT')) return 'CERTIFICATION';
    return 'OTHER';
};
